import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AlertService } from '@shared/services/alert.service';
import { ExportService } from 'src/app/export.service';
import { AskGenAiService } from '../../askGenAi.service';
import { PostgenieService } from '../../input/postgenie/postgenie.service';

@Component({
    selector: 'app-postgenie-output',
    templateUrl: './postgenie-output.component.html',
    styleUrls: ['./postgenie-output.component.scss'],
})
export class PostgenieOutputComponent implements OnInit {
    @Input() response: string = '';
    @Input() subscription_id: string = '';
    postResponse: any;
    responseInsights: any;
    responseHotTopics: any;
    responseRecentPosts: any;
    showResponse = false;
    isLoading = false;
    waitingMessage = false;
    safeHtml: SafeHtml;
    audioBlobUrl;
    audio;
    isCopied: boolean = false;
    speech: any;
    speechData: any;
    isPlaying: boolean = true;
    isPaused: boolean = false;
    audioDuration: any;
    fullContent: string;
    responseAudioRecentPosts: string;
    responseAudioInsights: string;
    responseAudioHotTopics: string;
    responseAudiopostResponse: string;
    responseList: any[] = [];
    linkedinPostRequest: any = '';

    constructor(
        private sanitizer: DomSanitizer,
        private askGenAi: AskGenAiService,
        private postgenieService: PostgenieService,
        private http: HttpClient,
        private alertService: AlertService,
        private exportService: ExportService,
    ) {}

    ngOnInit(): void {
        this.postgenieService.messageSubject.subscribe((prompt: any) => {
            this.linkedinPostRequest = prompt;
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        // console.log(this.response);
        if (this.response) {
            this.showResponse = true;
            this.response;
            if (this.response.includes(`id="recent-posts"`)) {
                this.responseRecentPosts = this.sanitizer.bypassSecurityTrustHtml(this.formatResponse(this.response));
                this.responseAudioRecentPosts = this.formatResponse(this.response);
            } else if (this.response.includes(`id="insights"`)) {
                this.responseInsights = this.sanitizer.bypassSecurityTrustHtml(this.formatResponse(this.response));
                this.responseAudioInsights = this.formatResponse(this.response);
            } else if (this.response.includes(`id="hot-topics"`)) {
                this.displayRelatedPeople();
            } else if (this.response.includes(`class="linkedin-post-generator"`)) {
                this.displayPosts();
            }
            this.parseHtml(this.formatResponse(this.responseAudiopostResponse.concat(this.responseAudioHotTopics, this.responseAudioInsights, this.responseAudioRecentPosts)));
        }
    }

    displayPosts() {
        this.postResponse = this.sanitizer.bypassSecurityTrustHtml(this.formatResponse(this.response));
        this.responseList.push(this.postResponse);
        this.responseAudiopostResponse = this.formatResponse(this.response);
    }

    displayRelatedPeople() {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.response;
        var liElements = tempDiv.querySelectorAll('li');
        liElements.forEach(function (li) {
            var name = li.textContent.trim();
            var anchor = document.createElement('a');
            anchor.href = 'https://www.linkedin.com/search/results/all/?keywords=' + encodeURIComponent(name);
            anchor.textContent = name;
            li.innerHTML = '';
            li.appendChild(anchor);
        });

        // Get the modified HTML as a string
        var modifiedHtmlString = tempDiv.innerHTML;
        console.log(modifiedHtmlString);

        this.responseHotTopics = this.sanitizer.bypassSecurityTrustHtml(this.formatResponse(modifiedHtmlString));
    }

    parseHtml(res: string) {
        this.speechData = document.createElement('div');
        this.speechData.innerHTML = res;

        // Remove the style elements from the temporary element
        const styleElements = this.speechData.querySelectorAll('style');
        styleElements.forEach((element) => {
            element.parentNode.removeChild(element);
        });

        // Extract plain text from the temporary element
        const plainText = this.speechData.textContent || this.speechData.innerText;
        // this.getOutput(plainText);
    }

    getOutput(text) {
        const key = 'AIzaSyAAYV5DVFzRQHIiqKKNBAS7JXfRh-pEirA';
        const url = `https://texttospeech.googleapis.com/v1/text:synthesize?key=${key}`;
        const params = {
            input: { text },
            voice: {
                name: 'en-US-Standard-B',
                languageCode: 'en-US',
                ssmlGender: 'FEMALE',
            },
            audioConfig: { audioEncoding: 'MP3' },
        };
        this.http.post(url, params).subscribe((response: any) => {
            this.audio = 'data:audio/mpeg;base64,' + response.audioContent;
            this.audioBlobUrl = this.sanitizer.bypassSecurityTrustUrl(this.audio);
        });
    }

    play() {
        this.isPlaying = false;
        this.isPaused = true;
        this.speech = document.getElementById('textToSpeech');
        this.speech.play();
    }

    pause() {
        this.isPlaying = true;
        this.isPaused = false;
        this.speech = document.getElementById('textToSpeech');
        this.speech.pause();
    }

    copyToClipboard(index: number) {
        const richText = document.getElementById('output-' + index).innerHTML;
        const blobHtml = new Blob([richText], { type: 'text/html' });
        const data = [
            new ClipboardItem({
                ['text/html']: blobHtml,
            }),
        ];

        navigator.clipboard.write(data).then(
            () => {
                this.alertService.openSnackBar('Copied to clipboard successfully!');
            },
            () => {},
        );
    }

    exportAsPdf() {
        let opt = {
            margin: 1,
            filename: 'myfile.pdf',
            image: { type: 'jpeg', quality: 1 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'cm', format: 'letter', orientation: 'portrait' },
        };

        this.exportService.exportAsPdf('output', opt);
    }

    formatResponse(htmlstr: string) {
        let strHtml = htmlstr;
        let parser = new DOMParser();
        let htmlDoc = parser.parseFromString(strHtml, 'text/html');
        let images = htmlDoc.getElementsByTagName('img');

        htmlstr = htmlstr.replace('```', '');
        //Checks for images and remove images
        while (images.length > 0) {
            images[0].parentNode.removeChild(images[0]);
        }

        // Convert back to string
        return new XMLSerializer().serializeToString(htmlDoc);
    }

    gotoLinkedin() {
        window.open('https://linkedin.com', '_blank');
    }

    makeTextShorter(index: number) {
        console.log(index);
    }

    makeTextCreative(index: number) {
        const modelParams = {
            max_output_tokens: 350,
            temperature: 0,
            top_p: 0.95,
            top_k: 40,
        };
        this.callPalmWithParams(this.linkedinPostRequest, undefined, modelParams, index);
    }

    toggleEmojis(type: string, index: number) {
        let prompt = document.getElementById('output-' + index).innerHTML;
        const modelParams = {
            max_output_tokens: 350,
            temperature: 0.6,
            top_p: 0.95,
            top_k: 40,
        };
        if (type === 'add') {
            prompt = "Can you add emoticons to the following html content wherever you think they could enhance the user's experience and you should respond with the same html along with emoticons. Do not add any additional text apart from the html. \n\n\n" + prompt;
        } else {
            prompt = "Can you remove any emoticons that you find in the following content. Your response should be the same input html without the emoticons.  Do not add any additional text apart from the html. " + prompt;
        }
        this.callPalmWithParams(prompt, undefined, modelParams, index);
    }

    callPalmWithParams(prompt: string, model: string = 'text-bison', params: any, index: number): void {
        this.askGenAi.askGenAi(this.subscription_id, prompt, undefined, model, params).subscribe((data) => {
            const resp = this.sanitizer.bypassSecurityTrustHtml(this.formatResponse(data.model_responses[0]));
            this.responseList[index] = resp;
        });
    }
}
